/* =====================================================================
   MCO Expandable — Phase 1 (2026-04-24)
   Attaches click handlers to every [data-mco-expandable] on the page.
   Toggles .is-expanded class; updates aria-expanded and the button label.
   ===================================================================== */

(function () {
  'use strict';

  function initExpandable(root) {
    var btn = root.querySelector('.mco-expandable__toggle');
    var textSpan = root.querySelector('.mco-expandable__toggle-text');
    if (!btn || !textSpan) return;

    var labelCollapsed = btn.getAttribute('data-label-collapsed') || 'Show more';
    var labelExpanded = btn.getAttribute('data-label-expanded') || 'Show less';

    // If content is already shorter than the cap, hide the toggle entirely
    var content = root.querySelector('.mco-expandable__content');
    var fade = root.querySelector('.mco-expandable__fade');
    if (content) {
      var capPx = parseInt(getComputedStyle(root).getPropertyValue('--mco-expandable-collapsed-height'), 10) || 480;
      if (content.scrollHeight <= capPx + 24) {
        btn.style.display = 'none';
        if (fade) fade.style.display = 'none';
        content.style.maxHeight = 'none';
        return;
      }
    }

    btn.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      textSpan.textContent = expanded ? labelExpanded : labelCollapsed;
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-mco-expandable]');
    Array.prototype.forEach.call(nodes, initExpandable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
